import { I18nextProvider } from "react-i18next";
// Bootstrap do navegador (React): QueryClient + Router. Toda a regra anti-botão-falso continua
// em view-model/capability/registry-client (agnósticas de framework). Aqui só montamos os providers.
import React, { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import i18n, { i18nReady } from "./i18n.js";
import { QueryClientProvider } from "@organizacaox/lai-design-system/query";
import { RouterProvider } from "@tanstack/react-router";
import "./index.css";
import { router } from "./router.js";
import { queryClient } from "./lib/query-client.js";
import { AppErrorBoundary } from "./lib/app-error-boundary.js";
import { registerAppServiceWorker } from "./lib/app-sw-update.js";
import { initAnalytics } from "./lib/analytics-loader.js";

// Devtools só em desenvolvimento. `import.meta.env.DEV` vira `false` no build de
// produção, então o import() é eliminado (tree-shaking) e não pesa o bundle do site.
const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() =>
      import("@tanstack/react-query-devtools").then((m) => ({ default: m.ReactQueryDevtools })),
    )
  : () => null;

// Antes do render: Consent Mode do GA em "denied" e, só se já houver aceite de
// análise de uso guardado, carrega GA4, Clarity e PostHog. Sem aceite, nada de
// terceiro é baixado; o aviso de cookies (cookie-consent.tsx) pede a escolha.
initAnalytics();

const root = document.getElementById("app");
if (root) {
  // Espera o catálogo do idioma ativo antes do primeiro render. Os idiomas agora
  // são carregados sob demanda (src/i18n.ts) e renderizar antes disso pintaria a
  // chave crua ("common.language") por um frame. É uma requisição só, disparada
  // no mesmo instante que o bundle do app — sem estado de carregamento na tela.
  void i18nReady.then(() =>
    createRoot(root).render(
      <React.StrictMode>
        {/* Error boundary global: fora do RouterProvider de propósito — o
            CatchBoundary do router vive DENTRO dele e não cobre falha nos
            providers nem na própria montagem do router. */}
        <AppErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <I18nextProvider i18n={i18n}>
              <RouterProvider router={router} />
            </I18nextProvider>
            <Suspense fallback={null}>
              <ReactQueryDevtools initialIsOpen={false} />
            </Suspense>
          </QueryClientProvider>
        </AppErrorBoundary>
      </React.StrictMode>,
    ),
  );
}

// Registro do SW fora da árvore React: não depende da montagem e sobrevive a
// um erro de render (é justamente aí que a versão nova mais importa).
registerAppServiceWorker();
